import React, { useEffect, useState } from 'react';
import { Bot, Loader2 } from 'lucide-react';
import client from '../../api/client';

export const ConciergeDisclosures = ({ toast }) => {
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    client.get('/compliance/concierge-disclosures').then(({ data }) => setD(data)).catch(() => {});
  }, []);
  if (!d) return null;

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await client.put('/compliance/concierge-disclosures', d);
      setD(data);
      toast?.({ title: 'Disclosures saved' });
    } catch (e) {
      toast?.({ title: 'Could not save', description: e.message, variant: 'destructive' });
    } finally { setSaving(false); }
  };

  return (
    <section data-testid="concierge-disclosures" className="soft-card rounded-2xl p-6 bg-white border border-[#EFE3D8] mb-5 space-y-4">
      <div className="flex items-start gap-3">
        <Bot className="w-5 h-5 text-[#7B2C3B] mt-1" />
        <div>
          <h3 className="font-serif text-xl text-[#2A2A2A]">AI concierge disclosures</h3>
          <p className="text-xs text-[#6A6A6A]">Played to every caller before the AI concierge talks or anything is recorded. The greeting must say callers are speaking with an AI.</p>
        </div>
      </div>
      <div>
        <label className="text-xs uppercase tracking-wide text-[#6A6A6A]">AI greeting</label>
        <textarea data-testid="disclosure-ai-greeting" rows={3} value={d.ai_greeting} onChange={(e) => setD({ ...d, ai_greeting: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#EFE3D8] text-sm focus:outline-none focus:border-[#7B2C3B]" />
        <p className="text-[11px] text-[#9A8A7E] mt-1">Use {'{coupleNames}'} to insert your names.</p>
      </div>
      <label className="inline-flex items-center gap-2 text-sm text-[#3A3A3A] cursor-pointer">
        <input data-testid="disclosure-recording-toggle" type="checkbox" className="accent-[#7B2C3B] w-4 h-4" checked={d.recording_enabled} onChange={(e) => setD({ ...d, recording_enabled: e.target.checked })} />
        Record & transcribe calls
      </label>
      {d.recording_enabled && (
        <div>
          <label className="text-xs uppercase tracking-wide text-[#6A6A6A]">Recording notice</label>
          <input data-testid="disclosure-recording-notice" value={d.recording_notice} onChange={(e) => setD({ ...d, recording_notice: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#EFE3D8] text-sm focus:outline-none focus:border-[#7B2C3B]" />
        </div>
      )}
      <button data-testid="disclosure-save" onClick={save} disabled={saving} className="text-sm px-4 py-2 rounded-full bg-[#7B2C3B] text-white disabled:opacity-40 inline-flex items-center gap-1.5">
        {saving && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Save disclosures
      </button>
    </section>
  );
};

export default ConciergeDisclosures;
